import React from 'react';
import { Badge } from 'react-bootstrap';
import { Tooltip } from '@material-ui/core';
import { floatRenderer } from '../../../services/formatSvc';

const getItemStyle = (i) => ({ whiteSpace: 'pre-wrap', marginTop: i && 16 });

// const isApproved = (project) => [PS.approved, PS['-approved'], PS.expertsApproved].includes(project.status);
const renderApprovedBadge = (rowData) => <Badge pill bg={rowData.approvedInSelectedPeriod ? 'success' : 'secondary'}>&#x2713;</Badge>;
const renderArray = (array, field, renderAsFloat, renderElement = ((item, content) => content)) => {
  let extraHandler = (v) => v;

  if (renderAsFloat) extraHandler = (v) => floatRenderer(+v);

  const itemHandler = (item) => renderElement(item, extraHandler(field ? item[field] : item));

  return array.length > 1
    ? (
      <ul>
        {array.map((item, i) => <li style={getItemStyle(i)}>{itemHandler(item)}</li>)}
      </ul>
    ) : (
      <span style={getItemStyle()}>
        {
        array[0]
          ? itemHandler(array[0])
          : null
      }
      </span>
    );
};

const renderLetterTooltip = (r, content) => (
  <Tooltip placement="top" title={<span style={{ fontSize: 14 }}>{r.letter}</span>}>
    <span>
      {content}
      )
    </span>
  </Tooltip>
);

export const getColumns = (year, strategyType) => {
  const isNew = strategyType 
  ? year >= 2025 && (strategyType === 'goal' || strategyType === 'tech')
  : year >= 2025;

  return {
    project: [
      { title: 'Одобрен', field: 'approved', render: renderApprovedBadge },
      { title: 'Наименование проекта', field: 'name', cellStyle: { minWidth: '450px' } },
      { title: 'Руководитель проекта', field: 'head', cellStyle: { minWidth: '200px' } },
      { title: 'Дата начала', field: 'startDate', cellStyle: { minWidth: '200px' } },
      { title: 'Дата окончания', field: 'endDate', cellStyle: { minWidth: '200px' } },
      { title: 'Тип проекта', field: 'type', cellStyle: { minWidth: '200px' } },
      { title: '№ проекта', field: 'fullNumber' },
    ],

    result: [
      {
        title: 'Одобрен', field: 'approved', cellStyle: { minWidth: '55px' }, render: renderApprovedBadge,
      },
      { title: 'Наименование проекта', field: 'name', cellStyle: { minWidth: '300px' } },
      { title: 'Руководитель проекта', field: 'head', cellStyle: { minWidth: '200px' } },
      {
        title: 'Уникальный результат, продукт, услуга (план)', field: 'resultTitle', cellStyle: { minWidth: '450px', fontWeight: 'bold' }, render: (rowData) => renderArray(rowData.results, 'title'), 
      },
      { title: 'Значение (план)', field: 'resultValue', cellStyle: { fontWeight: 'bold' }, render: (rowData) => renderArray(rowData.results, 'value') },
      { title: 'Ед. измерения', field: 'resultUnit', cellStyle: { fontWeight: 'bold' }, render: (rowData) => renderArray(rowData.results, 'unit') },
      { title: 'Мероприятия (а-т)', field: 'resultLetter', render: (rowData) => renderArray(rowData.results, 'letterCode', false, renderLetterTooltip) },
      {
        title: 'Бюджет из средств гранта (руб.)', field: 'grant', cellStyle: { minWidth: '135px' }, render: (rowData) => renderArray(rowData.grant, 'value', true),
      },
      { title: 'Тип финансирования', field: 'type', hidden: isNew, render: (rowData) => renderArray(rowData.grant, 'funding') },
      { title: 'Тип проекта', field: 'type', cellStyle: { minWidth: '200px' } },
      { title: '№ проекта', field: 'fullNumber' },
    ],

    finance: [
      {
        title: 'Одобрен', field: 'approved', cellStyle: { minWidth: '55px' }, render: renderApprovedBadge,
      },
      { title: 'Наименование проекта', field: 'name', cellStyle: { minWidth: '300px' } },
      { title: 'Руководитель проекта', field: 'head', cellStyle: { minWidth: '200px' } },
      {
        title: 'Бюджет из средств гранта (руб.)', field: 'budget', cellStyle: { minWidth: '135px' }, render: (rowData) => renderArray(rowData.grant, 'value', true),
      },
      {
        title: 'Бюджет из средств софинансирования (руб.)', field: 'nonGrant', cellStyle: { minWidth: '135px' }, render: (rowData) => floatRenderer(rowData.nonGrant.value),
      },
      {
        title: 'Ключевой показатель проекта', field: 'uniqueResult', cellStyle: { minWidth: '400px' }, render: (rowData) => renderArray(rowData.pcs, 'name'),
      },
      { title: 'Значение ключевого показателя', field: 'grant', render: (rowData) => renderArray(rowData.pcs, 'aggValue') },
      { title: 'Ед. измерения', field: 'unit', render: (rowData) => renderArray(rowData.pcs, 'unit') },
      { title: 'Тип финансирования', field: 'type', hidden: isNew, render: (rowData) => renderArray(rowData.grant, 'funding') },
      { title: 'Тип проекта', field: 'type', cellStyle: { minWidth: '200px' } },
      { title: '№ проекта', field: 'fullNumber' },
    ],
  }
};

const extractData = {
  project: () => [],

  result: () => [],

  finance: () => [],
};
